import React from 'react';
import { usePlayerCache } from '../contexts/PlayerCacheContext';
import { useStatsModal } from '../contexts/StatsModalContext';

/**
 * Renders player name with apartment short code + flat number (e.g. "TA-101").
 * When linkToProfile is true, clicking the name opens the player stats modal (popup).
 */
export default function PlayerNameWithApartment({ playerId, className, inline, linkToProfile = true }) {
  const { getPlayerName, getPlayerApartmentFlat } = usePlayerCache();
  const { openProfileModal } = useStatsModal();
  if (!playerId) return <span>—</span>;
  const name = getPlayerName(playerId);
  const apt = getPlayerApartmentFlat(playerId);
  const aptDisplay = (apt && apt.trim()) ? apt.trim() : '—';
  const wrappedName = linkToProfile ? (
    <button type="button" onClick={() => openProfileModal(playerId)} className="player-name-link"><span className="player-name">{name}</span></button>
  ) : (
    <span className="player-name">{name}</span>
  );
  if (inline) {
    return (
      <span className={className}>
        {wrappedName}
        <span className="player-apartment-flat" style={{ marginLeft: '6px', fontSize: '0.85em', color: '#666' }}>
          {' '}({aptDisplay})
        </span>
      </span>
    );
  }
  return (
    <span className={className} style={{ display: 'inline-block' }}>
      {wrappedName}
      <span className="player-apartment-flat" style={{ display: 'block', fontSize: '0.85em', color: '#666', marginTop: '2px' }}>
        {aptDisplay}
      </span>
    </span>
  );
}
